import { Reducer, useReducer } from "react";

export type CreateInitialState = <T>(state: T, defaultState: Partial<T>) => T;
/* `export const createInitialState` 是一个接受两个参数的函数：`T` 类型的`state` 和`Partial<T>`
类型的`defaultState`。它返回一个合并了 `state` 和 `defaultState` 对象的新对象。此函数用于为减速器创建初始状态。 */
export const createInitialState: CreateInitialState = <T>(
  state: T,
  defaultState: Partial<T>,
): T => {
  return Object.assign({}, state, defaultState);
};

export type StateActions<T, P = string> = Partial<T> & {
  type: P;
};

export type StateReducer<T, P = any> = (
  state: T,
  action: StateActions<T, P>,
) => T;

/* `export const useCreateReducer` 是一个接受三个参数的函数：`stateReducer`、`state` 和
`defaultState`。它返回一个包含当前状态和调度函数的元组。 `useCreateReducer` 函数使用 React 中的 `useReducer` 钩子来创建一个 reducer
函数，该函数接受当前状态和一个动作对象，并根据动作返回一个新状态。初始状态是通过调用 createInitialState 函数创建的，该函数合并了 state 和 defaultState
对象。此函数对于为 React 组件创建 reducer 和初始状态很有用。 */
export const useCreateReducer = <T, ActionType = any>(
  stateReducer: StateReducer<T, ActionType>,
  state: T,
  defaultState: Partial<T>,
) => {
  return useReducer<Reducer<T, StateActions<T, ActionType>>>(
    stateReducer,
    createInitialState(state, defaultState),
  );
};
